import { FC } from 'react';
import { Skeleton } from '@mui/material';
import React from 'react';

const TableSkeleton: FC = () => (
  <>
    <Skeleton
      variant="rectangular"
      height={57}
      sx={{
        margin: '10px 0 10px 0'
      }}
    />
    <Skeleton variant="rectangular" height={300} />
  </>
);

export default TableSkeleton;
